import React from 'react'

export default function DashFooter() {
  return (
    <div className='flex items-center justify-between p-4 font-englishTitle'>
      <span>Admin Dashboard</span>
      <span>Peidaa Group</span>
    </div>
  )
}
